<div class="auth-main container-fluid m-auto">
  <div class="auth-wrapper version-1">
    <div class="auth-form">
      <div class="main-form">
        <div class="card p-5">
          <div class="text-center">
            <a href="javascript:">
              <img style="width: 180px" src="../../../../../../assets/images/application/blue-ocean.png" alt="logo" />
            </a>
          </div>

          <div class="text-center mb-4 fs-5 fw-bold">Bienvenido a Blue Ocean</div>
          <form [formGroup]="loginForm" class="text-start">
            <label for="usuario" class="fw-bold">Usuario</label>
            <div class="form-group mt-2">
              <input
                type="text"
                class="form-control form-control-lg"
                formControlName="usuario"
                [ngClass]="{ 'is-invalid': submitted && formValues?.['usuario'].errors }"
              />
              <div *ngIf="submitted && formValues?.['usuario'].errors" class="invalid-feedback">Usuario Requerido</div>
            </div>
            <label for="contrasenia" class="fw-bold mt-3">Contraseña</label>
            <div class="form-group mt-2">
              <input
                type="password"
                id="inputPassword6"
                class="form-control"
                aria-describedby="passwordHelpInline"
                formControlName="contrasenia"
                [ngClass]="{ 'is-invalid': submitted && formValues?.['contrasenia'].errors }"
              />
              <div *ngIf="submitted && formValues?.['contrasenia'].errors" class="invalid-feedback">Contraseña Requerida</div>
            </div>
          </form>
          <div class="d-flex mt-4">
            <button class="btn boton w-100 d-flex align-items-center justify-content-center gap-2" (click)="onSubmit()" type="button">
              <i class="ti ti-login-2 me-1"></i>
              Iniciar Sesión
            </button>
          </div>
          <div *ngIf="errorMensaje" class="text-danger text-center mt-3">{{ errorMensaje }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
